import { BaseRestDataProvider } from './BaseRestDataProvider';

export interface Project {
  id?: string;
  name: string;
  description?: string;
  status?: string;
  startDate?: string;
  endDate?: string;
  budget?: number;
  isFixedPrice?: boolean;
  fixedPriceContingencyPercentage?: number;
  vatPercentage?: number;
}

export class ProjectsRestDataProvider extends BaseRestDataProvider {
  constructor() {
    super('/v1/projects');
  }

  getAll(): Promise<Project[]> {
    return this.get<Project[]>(``);
  }

  getById(id: string): Promise<Project> {
    return this.get<Project>(`/${id}`);
  }

  create(project: Project): Promise<Project> {
    return this.post<Project>(``, project);
  }

  update(id: string, project: Project): Promise<void> {
    return this.put<void>(`/${id}`, project);
  }

  delete(id: string): Promise<void> {
    return super.delete(`/${id}`);
  }
}
